module.exports = __webpack_public_path__ + "static/media/icey4x.757bd290.png";